import axios from '../../utils/axios';
import { BAD_REQUEST, INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const postSurveyEmails = async (postInfo) => {
  try {
    const { data } = await axios.post('/api/survey-emails', postInfo);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    let status;
    if (err.response.status === BAD_REQUEST.status) {
      status = BAD_REQUEST.status;
    } else {
      status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    }
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSurveyEmail = async (id) => {
  try {
    const { data } = await axios.get(`/api/survey-emails/${id}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const putSurveyEmail = async (surveyId, payload) => {
  try {
    const { data } = await axios.put(`/api/survey-emails/${surveyId}`, payload);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

const postUploadExcel = async (file, model) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await axios.post(`/api/survey-emails/upload-excel?model=${model}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    const errorMessage = (err.response && err.response.data && err.response.data.data)
      ? err.response.data.data.errorMessage : 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.';

    return {
      success: false,
      status,
      message,
      data: {
        errorMessage,
      },
    };
  }
};

export {
  postSurveyEmails,
  getSurveyEmail,
  putSurveyEmail,
  postUploadExcel,
};
